import { render, staticRenderFns } from "./EmailChargesModal.vue?vue&type=template&id=82330ae0&scoped=true"
import script from "./EmailChargesModal.vue?vue&type=script&lang=js"
export * from "./EmailChargesModal.vue?vue&type=script&lang=js"
import style0 from "./EmailChargesModal.vue?vue&type=style&index=0&id=82330ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82330ae0",
  null
  
)

export default component.exports